import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  ownerId: string;
}

export const useGetOwnerDetail = ({
  ownerId,
}: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.GET_OWNER_DETAILS, { ownerId: ownerId }],
    {
      enabled: !!ownerId,
      retry: false,
      refetchOnWindowFocus: false,
      notifyOnChangeProps: [
        "data",
        "error",
        "isError",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};
